module.exports = __webpack_public_path__ + "static/media/injected.00ddade1.svg";